import React, { useRef, useEffect } from "react";

export default function AssessmentsPlanFollowUp({ data, onChange, templateId, isEditing=true }) {
  const set = (k, v) => onChange({ ...data, [k]: v });
  const assessmentsRef = useRef(null);
  const treatmentRef = useRef(null);
  const treatment1Ref = useRef(null);
  const followUpRef = useRef(null);

  const adjustTextareaHeight = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleAssessmentsChange = (event) => {
    set("Assessments", event.target.value);
    adjustTextareaHeight(event.target);
  };

  const handleTreatmentChange = (event) => {
    set("Treatment", event.target.value);
    adjustTextareaHeight(event.target);
  };

  const handleTreatment1Change = (event) => {
    set("Treatment1", event.target.value);
    adjustTextareaHeight(event.target);
  };

  const handleFollowUpChange = (event) => {
    set("FollowUp", event.target.value);
    adjustTextareaHeight(event.target);
  };

  useEffect(() => {
    adjustTextareaHeight(assessmentsRef.current);
    adjustTextareaHeight(treatmentRef.current);
    adjustTextareaHeight(treatment1Ref.current);
    adjustTextareaHeight(followUpRef.current);
  }, [data.Assessments, data.Treatment, data.Treatment1, data.FollowUp]);

  const is774 = templateId === "100001774";

  return (
    <div className="cn-card">
      <h3>Assessments / Plan of Care / Follow Up</h3>
      <label>Assessments</label>
      <textarea 
        ref={assessmentsRef}
        rows={1} 
        value={data.Assessments || ""} 
        onChange={handleAssessmentsChange} 
        disabled={!isEditing}
        style={{
          width: "100%",
          minHeight: "40px",
          overflow: "hidden",
          resize: "none",
          boxSizing: "border-box"
        }}
      />
      <label>Treatment / Plan of Care</label>
      <textarea 
        ref={treatmentRef}
        rows={1} 
        value={data.Treatment || ""} 
        onChange={handleTreatmentChange} 
        disabled={!isEditing}
        style={{
          width: "100%",
          minHeight: "40px",
          overflow: "hidden",
          resize: "none",
          boxSizing: "border-box"
        }}
      />
      {is774 && (
        <>
          <label>Treatment1 / Visit Summary</label>
          <textarea 
            ref={treatment1Ref}
            rows={1} 
            value={data.Treatment1 || ""} 
            onChange={handleTreatment1Change} 
            disabled={!isEditing}
            style={{
              width: "100%",
              minHeight: "40px",
              overflow: "hidden",
              resize: "none",
              boxSizing: "border-box"
            }}
          />
        </>
      )}
      <label>Follow Up</label>
      <textarea 
        ref={followUpRef}
        rows={1} 
        value={data.FollowUp || ""} 
        onChange={handleFollowUpChange} 
        disabled={!isEditing}
        style={{
          width: "100%",
          minHeight: "40px",
          overflow: "hidden",
          resize: "none",
          boxSizing: "border-box"
        }}
      />
    </div>
  );
}